import React, { useEffect } from 'react';
import styled from 'styled-components';
import { FiX, FiZoomIn, FiZoomOut } from 'react-icons/fi';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  cursor: pointer;
`;

const ModalContent = styled.div`
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ZoomedImage = styled.img`
  max-width: 90vw;
  max-height: 90vh;
  object-fit: contain;
  transition: transform 0.3s ease;
  cursor: ${props => props.$isZoomed ? 'zoom-out' : 'zoom-in'};
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  transition: background-color 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const ZoomButton = styled.button`
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10001;
  transition: background-color 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const WhatsAppImageModal = ({ imageUrl, caption, onClose }) => {
  const [isZoomed, setIsZoomed] = React.useState(false);

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'Escape') {
        onClose();
      } else if (e.key === ' ') {
        setIsZoomed(!isZoomed);
      }
    };

    document.addEventListener('keydown', handleKeyPress);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
      document.body.style.overflow = 'unset';
    };
  }, [onClose, isZoomed]);

  const handleToggleZoom = (e) => {
    e.stopPropagation();
    setIsZoomed(!isZoomed);
  };

  const handleClickOverlay = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ModalOverlay onClick={handleClickOverlay}>
      <ModalContent>
        <CloseButton onClick={onClose}>
          <FiX />
        </CloseButton>
        
        <ZoomButton onClick={handleToggleZoom}>
          {isZoomed ? <FiZoomOut /> : <FiZoomIn />}
        </ZoomButton>

        <ImageContainer onClick={handleToggleZoom}>
          <ZoomedImage
            src={imageUrl}
            alt={caption || "Imagem do WhatsApp"}
            $isZoomed={isZoomed}
            style={{
              transform: isZoomed ? 'scale(1.5)' : 'scale(1)'
            }}
            onClick={(e) => e.stopPropagation()}
          />
        </ImageContainer>

        {caption && (
          <div style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0, 0, 0, 0.8)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            maxWidth: '80%',
            textAlign: 'center',
            fontSize: '14px'
          }}>
            {caption}
          </div>
        )}
      </ModalContent>
    </ModalOverlay>
  );
};

export default WhatsAppImageModal;

